import { QueryKeys } from "@/constants";
import { queryClient } from "@/hooks/use-query-client";
import type { CourtOrderDependentType } from "@/model/court-order-dependents";
import type { Relation } from "@/model/demographics";

type MemberType = {
  [key: string]: {
    [key: string]: Relation;
  };
};

export const updateCacheWithCourtOrderDependents = (
  courtOrderDependents: CourtOrderDependentType[],
  selfMemberId: string,
) => {
  const members = queryClient.getQueryData([QueryKeys.MEMBERS]);
  const dependents = queryClient.getQueryData([QueryKeys.DEPENDENTS]);
  if (members) {
    Object.keys(members).forEach((key) => {
      const keyStr = key.toString();
      if (
        keyStr !== selfMemberId && // don't remove if it's loggedIn user's memberId
        courtOrderDependents.some((a) => a.memberId === keyStr)
      ) {
        delete (members as MemberType)[keyStr];
      }
    });
    queryClient.setQueryData([QueryKeys.MEMBERS], members);
  }
  if (dependents) {
    const updatedDependents = (dependents as Relation[]).filter(
      (item) => !courtOrderDependents.some((a) => a.memberId === item.memberId),
    );
    queryClient.setQueryData([QueryKeys.DEPENDENTS], updatedDependents);
  }
};
